import { TUploadStep, TUploadStepAction, UPLOADSTAGELIST } from "../types";

// Reducer управляет ТОЛЬКО переходами между шагами
export const modalReducer = (
    state: TUploadStep,
    action: TUploadStepAction,
): TUploadStep => {
    switch (action.type) {
        case "UPLOAD_START":
            return UPLOADSTAGELIST.Upload;
        case "PROCESSING":
            return UPLOADSTAGELIST.Processing;
        case "ARCHIVE_ERROR":
            return UPLOADSTAGELIST.ArchiveError;
        case "UPLOAD_SUCCESS":
            return UPLOADSTAGELIST.ResultSuccess;
        case "UPLOAD_PARTIAL":
            return UPLOADSTAGELIST.ResultPartial;
        case "UPLOAD_ERROR":
            return UPLOADSTAGELIST.ResultError;
        default:
            return state;
    }
};
